import axios from "../../utils/axios";
import { BASE_API } from "../../config/app";
// 获取列表信息
export function getList(moduleKey, params, partKey, url) {
  return axios({
    url: BASE_API.rep(url || BASE_API.basis.list.url, moduleKey, partKey),
    method: "get",
    params: params
  });
}
